import { useEffect, useMemo } from "react";
import { RouterProvider } from "react-router-dom";
import "./App.scss";
import Loading from "./components/Loading";
import { RESOURCE_TYPE_ENUM } from "./constants";
import { useBootstrapAcMenus } from "./hook/useBootstrapAcMenus";
import { useFetchPrivilege } from "./hook/useFetchPrivilege";
import { createAppRouter } from "./routes/route";
import { useConfigStore } from "./store/config";

function App() {
  const [updatePrivilege, matchedAcMenus] = useConfigStore((state) => [
    state.updatePrivilege,
    state.matchedAcMenus,
  ]);
  const { data: privilegeRes } = useFetchPrivilege();
  const { ready: acMenusReady } = useBootstrapAcMenus();

  useEffect(() => {
    if (!privilegeRes) return;
    updatePrivilege(
      privilegeRes?.data.filter(
        (item: any) =>
          item.resourceType === RESOURCE_TYPE_ENUM.MENU ||
          item.resourceType === RESOURCE_TYPE_ENUM.PRIVILEGE
      )
    );
  }, [privilegeRes?.data, updatePrivilege]);

  const router = useMemo(() => {
    if (!acMenusReady) return null;
    return createAppRouter(matchedAcMenus);
  }, [acMenusReady, matchedAcMenus]);

  if (!acMenusReady || !router) {
    return (
      <div className="rtq-app" data-testid="rtq-app">
        <Loading open={true} />
      </div>
    );
  }

  return (
    <div className="rtq-app" data-testid="rtq-app">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
